export const PRICES = {
  0: '20-50k',
  1: '50-100k',
  2: '100-500K',
  3: '> 1,000K',
};
